import { Absent_getInstance17o8jlyfouexf as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinInputClass;
function PinInput() {
  if (PinInputClass === VOID) {
    class $ {
      constructor(id, icon, name) {
        icon = icon === VOID ? Absent_getInstance() : icon;
        name = name === VOID ? Absent_getInstance() : name;
        this.f6q_1 = id;
        this.g6q_1 = icon;
        this.h6q_1 = name;
      }
      toString() {
        return 'PinInput(id=' + this.f6q_1.toString() + ', icon=' + toString(this.g6q_1) + ', name=' + toString(this.h6q_1) + ')';
      }
      hashCode() {
        var result = this.f6q_1.hashCode();
        result = imul(result, 31) + hashCode(this.g6q_1) | 0;
        result = imul(result, 31) + hashCode(this.h6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinInput()))
          return false;
        if (!this.f6q_1.equals(other.f6q_1))
          return false;
        if (!equals(this.g6q_1, other.g6q_1))
          return false;
        if (!equals(this.h6q_1, other.h6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinInput');
    PinInputClass = $;
  }
  return PinInputClass;
}
//region block: exports
export {
  PinInput as PinInput9votjh1m54tp,
};
//endregion

//# sourceMappingURL=PinInput.mjs.map
